import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as InfoIcon } from "../../assets/icons/info-icon.svg";
import { ReactComponent as ShekelLightIcon } from "../../assets/icons/shekel-light-icon.svg";
import { formatAmountWithoutDecimals } from "@/util";
import digitalWalletStore from "@/stores/digital.wallet.store";

interface ITotalSumBalance {
    currencyCode?: string;
}

const TotalSumBalance: FC<ITotalSumBalance> = (props: ITotalSumBalance) => {
    const { t } = useTranslation();
    return (
        <Grid>
            <Box>
                <Typography className="total-sum-info-block-title">
                    {t("digitalWallet.TheFollowingSumsReferTitle")}
                </Typography>
            </Box>
            <Grid className="total-sum-info-block">
                <Grid item>
                    <Grid className="total-sum-tab-text">
                        <Grid>
                            <Typography>{t("digitalWallet.CurrentSubsidyBalanceOfAllEmployees")}</Typography>
                        </Grid>
                        <Grid className="total-sum-tab-tooltip">
                            <Tooltip title={t("digitalWallet.CurrentSubsidyBalanceOfAllEmployees")} placement="top">
                                <IconButton sx={{ padding: "0px" }}>
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid className="total-sum-currency-block">
                        <div>
                            <ShekelLightIcon />
                            {formatAmountWithoutDecimals(digitalWalletStore.currentSubsidyBalanceOfAllEmployees)}
                        </div>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid className="total-sum-tab-text">
                        <Grid>
                            <Typography>{t("digitalWallet.CurrentBalanceInActiveWallets")}</Typography>
                        </Grid>
                        <Grid className="total-sum-tab-tooltip">
                            <Tooltip title={t("digitalWallet.CurrentBalanceInActiveWallets")} placement="top">
                                <IconButton sx={{ padding: "0px" }}>
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid className="total-sum-currency-block">
                        <div>
                            <ShekelLightIcon />
                            {formatAmountWithoutDecimals(digitalWalletStore.currentBalanceInActiveWallets)}
                        </div>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid className="total-sum-tab-text">
                        <Grid>
                            <Typography>{t("digitalWallet.UnpaidSubsidies")}</Typography>
                        </Grid>
                        <Grid className="total-sum-tab-tooltip">
                            <Tooltip title={t("digitalWallet.UnpaidSubsidiesInfo")} placement="top">
                                <IconButton sx={{ padding: "0px" }}>
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid className="total-sum-currency-block">
                        <div>
                            <ShekelLightIcon />
                            {formatAmountWithoutDecimals(digitalWalletStore.unpaidSubsidies)}
                        </div>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid className="total-sum-tab-text">
                        <Grid>
                            <Typography>{t("digitalWallet.LalunCreditBalance")}</Typography>
                        </Grid>
                        <Grid className="total-sum-tab-tooltip">
                            <Tooltip title={t("digitalWallet.LalunCreditBalanceInfo")} placement="top">
                                <IconButton sx={{ padding: "0px" }}>
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid className="total-sum-currency-block">
                        <div>
                            <ShekelLightIcon />
                            {formatAmountWithoutDecimals(digitalWalletStore.subsidyBalance)}
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TotalSumBalance;
